import { AgGridReactProps } from '@ag-grid-community/react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';
import { getWithdrawalTypeDisplayValue } from '@tassat/fred-extended-definitions';
import React from 'react';

import history from 'Lib/browserHistory';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import { GridModelContext } from 'SharedComponents/sideList';

interface WithdrawalInstructionCellRendererProps extends AgGridReactProps {
    data: AccountWithdrawalDataRecord;
    cellHeight: number;
}

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        minHeight: '60px',
        maxHeight: '122px',
        height: (props: WithdrawalInstructionCellRendererProps) => props.cellHeight,
        color: 'inherit',
        textDecoration: 'inherit',
        padding: ' 0 2.5rem',
        backgroundColor: theme?.app?.applicationColors.enumColors.white || '#fff',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
                '#F3F3F3'
        }
    },
    name: {
        fontSize: '1.3rem',
        lineHeight: '1.5rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    emailContainer: { lineHeight: 0 },
    email: {
        fontSize: '.9rem',
        lineHeight: '1.2rem',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        paddingTop: '5px'
    },
    statusIconContainer: {
        width: 'auto',
        alignItems: 'center'
    },
    statusIcon: {
        width: 'auto',
        height: '22px',
        minWidth: '22px',
        paddingLeft: '10px',
        boxSizing: 'content-box'
    }
}));

export function WithdrawalInstructionCellRenderer(props: WithdrawalInstructionCellRendererProps) {
    const gridModel = React.useContext(GridModelContext);

    const { data } = props;

    const classes = muiStyles(props);

    const handleWithdrawalInstructionClick = (): void => {
        history.push(`/admin/firms/${data.FirmId}/withdrawals/${data.AccountWithdrawalDataId}`);
    };

    return (
        <Grid
            alignItems='center'
            className={`${classes.root} firm-info-cell`}
            container
            direction='row'
            justifyContent='space-around'
            onClick={handleWithdrawalInstructionClick}
            title={data.Description}
            wrap='nowrap'
        >
            <Grid
                container
                direction='column'
                item
                justifyContent='flex-start'
                spacing={0}
                wrap='nowrap'
                zeroMinWidth
            >
                <Typography
                    className={classes.name}
                    variant='h3'
                ><strong>{data.Description}</strong>
                </Typography>
                <Grid
                    className={classes.emailContainer}
                    container
                    direction='row'
                    item
                    spacing={1}
                    wrap='nowrap'
                >
                    <Grid
                        item
                        xs={10}
                    >
                        <Typography
                            className={classes.email}
                            variant='body2'
                        >
                            {getWithdrawalTypeDisplayValue(String.fromCharCode(data.WithdrawalType as unknown as number))}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default (WithdrawalInstructionCellRenderer);